export default "__VITE_ASSET__Bj2I64iQ__"